// Weekday arrays are Saturday-first (the Persian week start).
export const J_WEEKDAYS = [
    'شنبه',
    'یکشنبه',
    'دوشنبه',
    'سه‌شنبه',
    'چهارشنبه',
    'پنجشنبه',
    'جمعه',
]

export const J_WEEKDAYS_SHORT = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج']

// Latin equivalents, Saturday-first to share the weekday indexing above.
export const G_WEEKDAYS = [
    'Saturday',
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
]

export const G_WEEKDAYS_SHORT = ['S', 'S', 'M', 'T', 'W', 'T', 'F']

// Gregorian month names in English (used as the primary title in Gregorian mode).
export const G_MONTHS_EN = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

// Gregorian month names as written in Persian.
export const G_MONTHS = [
    'ژانویه',
    'فوریه',
    'مارس',
    'آوریل',
    'مه',
    'ژوئن',
    'ژوئیه',
    'اوت',
    'سپتامبر',
    'اکتبر',
    'نوامبر',
    'دسامبر',
]

export const H_MONTHS = [
    'محرم',
    'صفر',
    'ربیع‌الاول',
    'ربیع‌الثانی',
    'جمادی‌الاول',
    'جمادی‌الثانی',
    'رجب',
    'شعبان',
    'رمضان',
    'شوال',
    'ذیقعده',
    'ذیحجه',
]

export const J_MONTHS_IRANIAN = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
]

// The same months by the names Afghanistan uses: the zodiac signs.
export const J_MONTHS_AFGHAN = [
    'حمل',
    'ثور',
    'جوزا',
    'سرطان',
    'اسد',
    'سنبله',
    'میزان',
    'عقرب',
    'قوس',
    'جدی',
    'دلو',
    'حوت',
]

// The names on screen: one of the two lists above. services/settings swaps the
// contents in place, so every reader follows the setting without asking for it.
export const J_MONTHS = [...J_MONTHS_IRANIAN]
